import { areas } from './Areas/Areas'
import { crops } from './Crops/Crops'

export const GisApi = {
  areas,
  crops
}
